export const driverLicenseUrl = '/kierowca-kat-:category(b|c|ce|d)/';
export const passwordResetUrl = '/zresetuj-haslo/';
export const passwordSetUrl = '/zresetuj-haslo/:uid/:token/';
export const homeUrl = '/';
export const loginUrl = '/zaloguj/';
export const privacyPolicyUrl = '/polityka-prywatnosci/';
export const registerUrl = '/rejestracja/';
export const regulationUrl = '/regulamin/';
export const offlineUrl = '/offline/';

export const offerBasePath = '/oferta';

/** Paginated listing for crawlers: /oferty?page=N */
export const offerListingUrl = '/oferty';

/**
 * Homepage offer detail (list + detail layout).
 * Path is /oferta/:slugAndId where slugAndId = "${slug}-${id}".
 * Slug is for display only; offer is fetched by id.
 */
export const offerDetailUrl = `${offerBasePath}/:slugAndId`;

/**
 * Parse slugAndId from URL (last segment). Returns { slug, id }.
 * Id is the part after the last "-"; slug is everything before it.
 */
export function parseOfferDetailSlugAndId(slugAndId: string): { slug: string; id: string } {
  const lastDash = slugAndId.lastIndexOf('-');
  if (lastDash === -1) return { slug: '', id: slugAndId };
  return { slug: slugAndId.slice(0, lastDash), id: slugAndId.slice(lastDash + 1) };
}

/**
 * Build offer detail URL from slug and id.
 * Use generateOfferSlug(offer.title) for the slug.
 */
export function buildOfferDetailUrl(slug: string, id: string): string {
  const safeSlug = slug && slug.replace(/^-|-$/g, '') ? slug : 'o';
  return `${offerBasePath}/${safeSlug}-${id}`;
}

export const offerNewBasePath = '/oferta/nowa';
export const offerCreateUrl = `${offerNewBasePath}/`;
export const offerCreateEditUrl = `${offerNewBasePath}/:id/`;
export const offerAcknowledgementUrl = `${offerNewBasePath}/:id/dziekujemy-za-opublikowanie/`;
export const offerPaymentUrl = `${offerNewBasePath}/:id/platnosc/`;
export const offerSummaryUrl = `${offerNewBasePath}/:id/podsumowanie/`;

export const offerEditUrl = `${offerBasePath}/:id/edycja/`;
export const offerRepublishPaymentUrl = `${offerBasePath}/:id/platnosc/`;
export const offerRepublishUrl = `${offerBasePath}/wznow/:token/`;

export const userBasePath = '/uzytkownik';
export const userDatabaseUrl = `${userBasePath}/baza-danych`;
export const userOffersActiveUrl = `${userBasePath}/oferty/aktywne/`;
export const userOffersExpiredUrl = `${userBasePath}/oferty/wygasniete/`;
export const userOfferApplicationsUrl = `${userBasePath}/aplikacje/:offerId/`;

export const priceListUrl = '/cennik';

export const directAccessUrl = '/direct-access-to-polish-drivers';

export const blog = '/blog';
export const blogArticle = '/blog/:slug';

export const p24ReturnUrl = '/platnosc/potwierdzenie/';

export const notFoundUrl = '/404/';
export const serverErrorUrl = '/500/';
